import { ApocalypseFreespinResultPresentation } from "../freespin/ApocalypseFreespinResultPresentation";

export class ApocalypseFreespinBetterResultPresentation extends ApocalypseFreespinResultPresentation {
    constructor() {
        super(`ApocalypseFreespinBetterResultPresentation`);
    }
}
